export default "__VITE_ASSET__BDTpw$lN__"